module.exports = __webpack_public_path__ + "img/demo-booking-right-info.aa4878ea.webp";